import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

export default function ExecutionConditionsFilter({
  handleForm,
  currentValue,
}) {
  return (
    <>
      <P marginBottom={1}>
        <Trans>Execution Conditions</Trans>
      </P>
      <RadioGroup
        marginBottom={1}
        name="radio_execution_conditions"
        items={[
          { label: t`Both`, value: 'Both' },
          {
            label: t`With Execution Conditions`,
            value: 'With Execution Conditions',
          },
          {
            label: t`Without Execution Conditions`,
            value: 'Without Execution Conditions',
          },
        ]}
        vertical
        value={currentValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'executionConditions' });
        }}
      />
    </>
  );
}

ExecutionConditionsFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
};
